/**
 * “Ventas reales” = gross payments − vuelto efectivo − giro tarjeta (1×).
 * Prefer backend `total_ventas_reales` when present so UI/CSV/ticket stay aligned.
 */
export function computeTotalVentasReales(totalVentasBrutas, egresosVueltoEfectivo, egresosVueltoTarjeta) {
    return (
        (Number(totalVentasBrutas) || 0) -
        (Number(egresosVueltoEfectivo) || 0) -
        (Number(egresosVueltoTarjeta) || 0)
    );
}

/** Resolve from corte/cierre payload (backend field or local 1× formula). */
export function resolveTotalVentasReales(detail) {
    if (detail?.total_ventas_reales != null && Number.isFinite(Number(detail.total_ventas_reales))) {
        return Number(detail.total_ventas_reales);
    }
    const r = detail?.resumen_cierre || {};
    return computeTotalVentasReales(
        detail?.total_ventas,
        r.egresos_vuelto_efectivo,
        r.egresos_vuelto_tarjeta
    );
}
